import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Sidebar from './components/dashboard/Sidebar';
import Topbar from './components/dashboard/Topbar';
import MainHeader from './header/MainHeader';
import './components/dashboard/dashboard-layout.css';

export default function Meinmobile() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    const stored = localStorage.getItem('userData');
    if (stored) setUserData(JSON.parse(stored));
    
    // Add dashboard mode class to body to prevent double scrollbars
    document.body.classList.add('dashboard-mode');
    return () => {
      document.body.classList.remove('dashboard-mode');
    };
  }, []);

  return (
    <ConfigProvider theme={{ token: { colorPrimary: '#fe5a1d', colorLink: '#fe5a1d', colorLinkHover: '#d24613' } }}>
      <div className="dashboard-layout-wrapper">
        <Sidebar 
          isOpen={isSidebarOpen} 
          onClose={() => setIsSidebarOpen(false)} 
          userData={userData} 
        />
        <div className="dashboard-main-area">
          {/* Desktop Menu: MainHeader */}
          <div className="d-none d-lg-block w-100">
            <MainHeader />
          </div>
          
          {/* Mobile Menu: Topbar */}
          <div className="d-lg-none w-100">
            <Topbar 
              onToggleSidebar={() => setIsSidebarOpen(true)} 
              userData={userData} 
            />
          </div>
          
          <main className="dashboard-content-wrapper">
            <div className="dashboard-page-container">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </ConfigProvider>
  );
}
